import React from 'react';
import { withTheme } from '@ifit/themes/withTheme';
import classNames from 'classnames';
import styles from './index.module.scss';

export interface IProps {
  progress: string | number;
  height?: string | number;
  themeClass?: string;
  className?: string;
}

const ProgressBar = ({
  progress = 0,
  height = 4,
  themeClass,
  className,
  ...rest
}: IProps) => {
  let boundedProgress = Number(progress);
  const typedHeight = Number(height);

  if (boundedProgress > 100) {
    boundedProgress = 100;
  }

  if (boundedProgress < 0) {
    boundedProgress = 0;
  }

  const progressCSSValue = 100 - boundedProgress;

  const indicatorStyle = {
    right: `${progressCSSValue}%`,
  };

  const progressBarStyle = {
    height: `${typedHeight}px`,
  };

  return (

    <div
      className={classNames(
        styles['mp-progress-bar'],
        themeClass,
        className,
      )}
      style={progressBarStyle}
      data-testid="mp-progress-bar"
      {...rest}
    >
      <div
        className={styles.indicator}
        style={indicatorStyle}
        data-testid="mp-progress-bar-indicator"
      />
    </div>
  );
};

export default withTheme(ProgressBar);
